import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  card: {
    width: '100%',
    backgroundColor: theme.palette.background.default,
    border: 'none',
    boxShadow: 'none',
    gap: theme.spacing(3),
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(1),
      flexDirection: 'column'
    }
  },
  cardActionArea: {
    padding: '10px',
    display: 'flex',
    gap: theme.spacing(2),
    '&:hover': {
      borderRadius: '30px',
      backgroundColor: 'transparent',
      boxShadow: '0 4px 16 #ECECEC inset'
    },
    '&:hover .MuiCardActionArea-focusHighlight': {
      opacity: 0
    },
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(1),
      flexDirection: 'column'
    }
  },
  moreRecentImgContainer: {
    width: '50%',
    borderRadius: '20px',
    objectFit: 'cover',
    cursor: 'pointer',
    objectPosition: 'center center',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  moreRecentInformationContainer: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingRight: theme.spacing(2),
    '&.MuiCardContent-root': {
      padding: 0
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  category: {
    alignSelf: 'start',
    marginBottom: theme.spacing(1)
  },
  moreRecentTitle: {
    display: '-webkit-box',
    lineHeight: '1.2em',
    minHeight: '2.4em',
    boxOrient: 'vertical',
    lineClamp: 2,
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxLines: 2,
    marginBottom: theme.spacing(2),
    color: theme.palette.text.primary,
    width: '100%',
    textAlign: 'left',
    '&.MuiCardHeader-root': {
      padding: 0
    },
    [theme.breakpoints.up('lg')]: {
      '& .MuiTypography-h5': {
        fontSize: '1.5rem',
        minHeight: '2.6em'
      }
    }
  },
  moreRecentText: {
    display: '-webkit-box',
    lineHeight: '1.2em',
    minHeight: '4.4em',
    boxOrient: 'vertical',
    lineClamp: 4,
    WebkitLineClamp: 4,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxLines: 4,
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      ...theme.typography.body2,
      minHeight: '3.4em',
      lineClamp: 3,
      WebkitLineClamp: 3,
      maxLines: 3
    }
  },
  actionReadMore: {
    alignSelf: 'flex-end'
  },
  actionsButton: {
    padding: '6px 10px',
    backgroundColor: 'none',
    color: theme.palette.primary.dark,
    '&:hover': {
      textDecoration: 'underline',
      backgroundColor: 'transparent'
    },
    '&:active': {
      backgroundColor: 'transparent'
    }
  },
  mostRecentCarousel: {
    width: '100%',
    display: 'flex',
    alignItems: 'center'
  },
  mostRecentSwiperContainer: {
    width: '100%',
    paddingBottom: '28px !important',
    '& .swiper-pagination-lock': {
      display: 'flex !important',
      visibility: 'visible !important'
    },
    '& .swiper-pagination': {
      bottom: '0px !important'
    },
    '& .swiper-pagination-bullet': {
      backgroundColor: theme.palette.grey[300],
      opacity: 1
    },
    '& .swiper-pagination-bullet-active': {
      backgroundColor: theme.palette.primary.dark
    },
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '16px !important'
    }
  },
  mostRecentNavButton: {
    color: theme.palette.primary.contrastText,
    transition: 'color 0.3s ease',
    '&.swiper-button-disabled': {
      color: `${theme.palette.grey[300]} !important`,
      pointerEvents: 'auto'
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  }
}))
